// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"3a258314","185":"f1eb731e","242":"a06a26b2","243":"c4fd314a","294":"049441e2","338":"0124635e","787":"3bdc9602","936":"664d0454","981":"c3deb8f2"}[chunkId] + ".chunk.js";
};